module.exports = __webpack_public_path__ + "static/media/centro-bazterrica.dfade73e.svg";